export const RELEASE_STAGE = {
  STABLE: "stable",
  BETA: "beta",
};
